import Joi from "joi";
import errorsResolver from "../../../validation/schemeUtils";

const MIN_AMOUNT = 500;
const MAX_AMOUNT = 100000;
const MIN_TERM = 1;
const MAX_TERM = 25;
const MIN_ESTIMATED = 0;
const MAX_ESTIMATED = 1000000;
const DEFAULT_PRECISION_MESSAGE = 'Допускается не более 2 знаков после запятой';

const precisionValidation = (value, helpers) => {
  if (!/^\d+(\.\d{1,2})?$/.test(value.toString())) {
    return helpers.error('number.precision');
  }
  return value;
};

const approvalModalValidationScheme = Joi.object({
  approvedAmount: Joi.number()
    .min(MIN_ESTIMATED)
    .max(MAX_AMOUNT)
    .unsafe()
    .required()
    .custom(precisionValidation)
    .error(errorsResolver({
      numberBase: "Сумма заявки должна быть числом",
      numberMin: `Минимальное значение: ${MIN_AMOUNT}`,
      numberMax: `Максимальное значение: ${MAX_AMOUNT}`,
      required: "Сумма заявки обязательна",
      numberUnsafe: DEFAULT_PRECISION_MESSAGE,
      precision: DEFAULT_PRECISION_MESSAGE
    })),

  approvedTerm: Joi.number()
    .min(MIN_TERM)
    .max(MAX_TERM)
    .unsafe()
    .required()
    .error(errorsResolver({
      numberBase: "Срок заявки должен быть числом",
      numberMin: `Минимальное значение: ${MIN_TERM}`,
      numberMax: `Максимальное значение: ${MAX_TERM}`,
      required: "Срок заявки обязателен",
      numberUnsafe: `Максимальное значение: ${MAX_TERM}`
    })),

  estimatedValue: Joi.number()
    .min(MIN_ESTIMATED)
    .max(MAX_ESTIMATED)
    .unsafe()
    .required()
    .custom(precisionValidation)
    .error(errorsResolver({
      numberBase: "Оценочная стоимость должна быть числом",
      numberMin: `Минимальное значение: ${MIN_ESTIMATED}`,
      numberMax: `Максимальное значение: ${MAX_ESTIMATED}`,
      required: "Оценочная стоимость обязательна",
      numberUnsafe: DEFAULT_PRECISION_MESSAGE,
      precision: DEFAULT_PRECISION_MESSAGE
    })),
});

export default approvalModalValidationScheme;
